const API_URL = process.env.REACT_APP_SERVICE_HOST || 'https://cluby-api.herokuapp.com'
export {
  API_URL
};